import { store } from "../store";
import Controller from "./Controller";
import apiClientToken from "../plugins/axiosToken";

export default class EstadosService {
  getEstados(context) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .get(
          store.getters.getUrlServicios + "WCFEstados.svc/RestService/GetEstados"
        )
        .then(function (response) {
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al obtener los estados",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }

  getEstado(context, id) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .get(
          store.getters.getUrlServicios + "WCFEstados.svc/RestService/Get/" + id
        )
        .then(function (response) {
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al obtener el estado",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }

  addEstado(context, param) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .post(
          store.getters.getUrlServicios + "WCFEstados.svc/RestService/Add",
          param
        )
        .then(function (response) {
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al crear el estado",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }

  updateEstado(context, param) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .post(
          store.getters.getUrlServicios + "WCFEstados.svc/RestService/Update",
          param
        )
        .then(function (response) {
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al actualizar el estado",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }

  deleteEstado(context, id) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .post(
          store.getters.getUrlServicios + 
          "WCFEstados.svc/RestService/Delete/" + 
          id
        )
        .then(function (response) {
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al eliminar el estado",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }
}